export const NATIVE_SOL_UNIQUE_ADDRESS = "NATIVE_SOL_UNIQUE_ADDRESS";
